import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';

export interface AvatarProps {
    avatar: string | null;
    reporterName: string;
}

interface StyledAvatarProps
    extends JSSClassesProps<ComponentJSSClasses>,
        AvatarProps {}

export function Avatar(props: StyledAvatarProps) {
    const { classes, avatar, reporterName } = props;

    return (
        avatar ? (
                <img src={avatar} className={classes.avatar} alt={reporterName} />
            ) : (
                <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={classes.defaultAvatar}
                >
                    <path
                        d="M15.4859 0.739319C7.33806 0.739319 0.740051 7.35209 0.740051 15.5C0.740051 23.6478 7.33806 30.2606 15.4859 30.2606C23.6486 30.2606 30.2613 23.6478 30.2613 15.5C30.2613 7.35209 23.6486 0.739319 15.4859 0.739319ZM10.3345 9.5957C11.5596 9.5957 12.5486 10.5847 12.5486 11.8098C12.5486 13.0349 11.5596 14.0239 10.3345 14.0239C9.10933 14.0239 8.12037 13.0349 8.12037 11.8098C8.12037 10.5847 9.10933 9.5957 10.3345 9.5957ZM22.512 19.5591C21.1097 21.9799 18.4971 23.6183 15.5007 23.6183C12.5043 23.6183 9.89165 21.9799 8.48939 19.5591C8.20893 19.072 8.57795 18.4521 9.13885 18.4521H21.8625C22.4382 18.4521 22.7924 19.072 22.512 19.5591ZM20.6669 14.0239C19.4418 14.0239 18.4528 13.0349 18.4528 11.8098C18.4528 10.5847 19.4418 9.5957 20.6669 9.5957C21.892 9.5957 22.881 10.5847 22.881 11.8098C22.881 13.0349 21.892 14.0239 20.6669 14.0239Z"
                        fill="white"
                    />
                </svg>
            )
    );
}
